import React, { PropTypes } from 'react';
// import { Link } from 'react-router';
import ReactTooltip from 'react-tooltip';

export default class FooterButtons extends React.Component {

	render () {
		return (
			<div>
				<div className="footer-export-button">					
					<span className="footer-button-icon">						
						<span data-tip="Exportar Lista" onClick={() => this.props.export()}>
							<i className="fa fa-share" />
						</span>
						<ReactTooltip />
					</span>					
				</div>
				{/* <div className="footer-new-button">					
					<span className="footer-button-icon">
						<Link to="/admin/documents/create" style={{textDecoration: "none", color: "white"}}>
							<span data-tip="Novo Documento">+</span>
						</Link>
						<ReactTooltip />
					</span>					
				</div> */}
			</div>
		);
	}
}

FooterButtons.propTypes = {	
	export: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Documents/FooterButtons.js